module.exports = "/images/select-icon-selected.svg?a975af2384122f3ddcf47aa572c68b62";